import { ApiMetaData } from 'types/api';
import { AppThunk } from 'redux/store';
import { endpoints } from 'api/endpoints';
import { FilterWorkshop } from 'types/redux/state/workshop.state';
import { isSuccessResult } from 'utils/guards';
import { Json } from 'types/common';
import { Workshop } from 'types/api/responses/workshop';
import { ApiData, ApiMetaDataWorkshop, Office } from 'types/api/responses';
import { apiGet, apiPost } from 'api/karthus.client';
import { EditWorkshopRequest, Pager } from 'types/api/request';
import { WorkshopActions, WorkshopAction } from 'types/redux/actions/workshop.action';

export type ShopAllAction = {
  params: Pager;
  filterN: FilterWorkshop;
  lastSuccess?: () => void;
};

export const workshopAll = ({
  params,
  filterN,
  lastSuccess,
}: ShopAllAction): AppThunk<WorkshopAction> => {
  return async (dispatch) => {
    const filter = {
      ...filterN,
/*      Active: 'Active',*/
    };
    const cleanedFilter = Object.fromEntries(
      Object.entries(filter).filter(([, v]) => v !== null && v !== undefined && v !== ''),
    ) as typeof filter;
    dispatch({ type: WorkshopActions.workshopUpdate, isLoading: true });
    const response = await apiGet<ApiMetaDataWorkshop<Workshop[]>>(endpoints.workshop, {
      ...params,
      filter: cleanedFilter,
    });
    if (isSuccessResult(response.result)) {
      dispatch({ type: WorkshopActions.workshopFilter, filter: filterN });
      dispatch({
        type: WorkshopActions.workshopAll,
        workshops: {
          workshops: response.result.data,
          meta: response.result.meta,
        },
      });
      if (lastSuccess) {
        lastSuccess();
      }
    } else {
      dispatch({
        type: WorkshopActions.workshopUpdate,
        isLoading: false,
        error: response.result[0],
      });
    }
  };
};

export const workshopOffices = (filter: {
  ZoneId: number | null;
}): AppThunk<WorkshopAction> => {
  return async (dispatch) => {
    const myParams = {
      page: 1,
      size: 0,
    };
    dispatch({ type: WorkshopActions.workshopUpdate, isLoading: true });
    const response = await apiGet<ApiMetaData<Office[]>>(endpoints.branchOffcie, {
      ...myParams,
      filter,
    });
    if (isSuccessResult(response.result)) {
      dispatch({
        type: WorkshopActions.workshopSetOffices,
        branchOffices: {
          offices: response.result.data,
          meta: response.result.meta,
        },
      });
    } else {
      dispatch({
        type: WorkshopActions.workshopUpdate,
        isLoading: false,
        error: response.result[0],
      });
    }
  };
};

export const updateWorkshop = (
  params: EditWorkshopRequest,
): AppThunk<WorkshopAction, Promise<void>> => {
  return async (dispatch) => {
    dispatch({ type: WorkshopActions.workshopUpdate, isLoading: true });
    const response = await apiPost<ApiData<Workshop>>(endpoints.workshop, params as Json);
    if (isSuccessResult(response.result)) {
      dispatch({
        type: WorkshopActions.workshopUpdateItem,
        workshop: response.result.data,
      });

      return;
    }
    dispatch({
      type: WorkshopActions.workshopUpdate,
      isLoading: false,
      error: response.result[0],
    });
    throw response.result;
  };
};
